import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {ToastIcon} from './TestOfferInitiation';
import axios from "axios";
import { useSelector } from "react-redux";
import { server_API } from "../config";
import { selectCid } from "../features/companyid";


const createNotification = (cid, userid, type, title, message, subtask)=>{
    
    axios.post(`${server_API}/v2/notification/create`,{
      companyid:cid,
      userid:userid,
      notificationtype:type,
      notificationtitle:title,
      message:message,
      subtask:subtask
    })
    .then((res)=>{
      console.log(res);
      toast.success(message, {
        icon: <ToastIcon />,
      });


    })
    .catch((err)=>{
      console.log(err);
    })
}

const deleteBulkNotifications = (arr, cid)=>{
  const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Cookie", "Cookie_1=value");

const raw = JSON.stringify({
  "uuids": arr,
  "companyid": cid
});

const requestOptions = {
  method: "DELETE",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(`${server_API}/v2/notification/bulkdelete`, requestOptions)
  .then((response) => response.text())
  .then((result) => console.log(result))
  .catch((error) => console.error(error));
  
}

export {createNotification, deleteBulkNotifications} 